export default __webpack_public_path__ + "static/media/HostaAILogo.d556029c.svg";